import React from "react";
import { FormattedMessage } from "react-intl";

import ServiceWithDate from "./serviceWithDate";

const Fdd = ({
  rules,
  disabled,
  countryId,
  productId,
  formItemLayout,
  initialServices,
  getFieldDecorator,
}) =>
  rules.fixedDeliveryDate ? (
    <ServiceWithDate
      delivery
      checkDate
      disabled={disabled}
      countryId={countryId}
      productId={productId}
      label={
        <FormattedMessage id="consignment.services.fdd" defaultMessage="FDD" />
      }
      fieldName="deliveryDateTime"
      formItemLayout={formItemLayout}
      getFieldDecorator={getFieldDecorator}
      initialServiceDate={initialServices && initialServices.deliveryDateTime}
    />
  ) : (
    <></>
  );

export default Fdd;
